import { MenuItem } from '../layout/shared/models/menu.model';

// menu items for vertcal and detached layout
const MENU_ITEMS: MenuItem[] = [
  {
    key: 'home',
    label: 'Home',
    isTitle: false,
    icon: 'mdi mdi-home-outline',
    url: '/clientes',
    role: 'ROLE_HOME_VISUALIZAR',
  },
  {
    label: 'Operação',
    isTitle: true,
    show: true,
  },
  {
    key: 'demandas',
    label: 'Demandas',
    isTitle: false,
    icon: 'mdi mdi-clipboard-list-outline',
    url: '/central-demandas',
    role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
  },
  {
    key: 'central-agendas',
    label: 'Agenda',
    isTitle: false,
    icon: 'mdi mdi-calendar-check-outline',
    url: '/central-agendas',
    role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
  },
  {
    key: 'projetos',
    label: 'Projetos',
    isTitle: false,
    icon: 'mdi mdi-clipboard-list-outline',
    collapsed: true,
    children: [
      {
        key: 'projetos-lista',
        label: 'Projetos',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/projetos',
        parentKey: 'projetos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'tipos-projeto',
        label: 'Tipos de Projeto',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/central-demandas/tipos-projeto',
        parentKey: 'projetos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
    ],
  },
  {
    key: 'liderancas',
    label: 'Lideranças',
    isTitle: false,
    icon: 'mdi mdi-account-tie',
    collapsed: true,
    children: [
      {
        key: 'lideranca-crud',
        label: 'Lideranças',
        url: '/lideranca',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'liderancas',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'tipo-lideranca',
        label: 'Tipos de Liderança',
        url: '/tipo-lideranca',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'liderancas',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'categoria-tipo-lideranca',
        label: 'Categorias de Tipo de Liderança',
        url: '/categoria-tipo-lideranca',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'liderancas',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
    ],
  },
  {
    key: 'central-mandatos',
    label: 'Compromissos',
    isTitle: false,
    icon: 'mdi mdi-gavel',
    collapsed: true,
    children: [
      {
        key: 'compromisso-campanha',
        label: 'Compromissos de Campanha',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/central-mandatos/compromisso-campanha',
        parentKey: 'central-mandatos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'area-tematica',
        label: 'Áreas Temáticas',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/central-mandatos/area-tematica',
        parentKey: 'central-mandatos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'tipo-compromisso',
        label: 'Tipos',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/central-mandatos/tipo-compromisso',
        parentKey: 'central-mandatos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'origem-compromisso',
        label: 'Origens',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/central-mandatos/origem-compromisso',
        parentKey: 'central-mandatos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
    ],
  },
  {
    key: 'oportunidades-politicas',
    label: 'Oportunidades Políticas',
    isTitle: false,
    icon: 'mdi mdi-lightbulb-outline',
    url: '/oportunidades-politicas',
    role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
  },
  {
    key: 'questionamentos',
    label: 'Questionamentos',
    isTitle: false,
    icon: 'mdi mdi-comment-question-outline',
    url: '/questionamentos',
    role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
  },
  {
    key: 'gestao-cargos',
    label: 'Gestão de Cargos',
    isTitle: false,
    icon: 'mdi mdi-briefcase-outline',
    collapsed: true,
    children: [
      {
        key: 'vagas',
        label: 'Vagas',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/gestao-cargos/vagas',
        parentKey: 'gestao-cargos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'relatorio-vagas',
        label: 'Relatório de Vagas',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/gestao-cargos/relatorio-vagas',
        parentKey: 'gestao-cargos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'indicados',
        label: 'Indicados',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/gestao-cargos/indicados',
        parentKey: 'gestao-cargos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'funcoes-cliente',
        label: 'Funções Cliente',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/gestao-cargos/funcoes-cliente',
        parentKey: 'gestao-cargos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'orgaos-estrategicos',
        label: 'Órgãos Estratégicos',
        url: '/orgaos-estrategicos',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'gestao-cargos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
    ],
  },
  {
    key: 'atividades',
    label: 'Atividades',
    isTitle: false,
    icon: 'mdi mdi-format-list-checks',
    url: '/central-demandas/atividades',
    role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
  },
  {
    label: 'Articulação',
    isTitle: true,
    show: true,
  },
  {
    key: 'pessoas',
    label: 'Pessoas',
    isTitle: false,
    icon: 'mdi mdi-account-group',
    url: '/person',
    role: 'ROLE_BLACKLIST_VISUALIZAR',
  },
  {
    key: 'apoiadores',
    label: 'Apoiadores',
    isTitle: false,
    icon: 'mdi mdi-account-multiple-check',
    collapsed: true,
    children: [
      {
        key: 'pessoa-fisica',
        label: 'Pessoa Física',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/apoiadores',
        parentKey: 'apoiadores',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'entidades',
        label: 'Entidades',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/entidades-apoiadoras',
        parentKey: 'apoiadores',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
    ],
  },
  {
    key: 'grupos-trabalho',
    label: 'Grupos de Trabalho',
    isTitle: false,
    icon: 'mdi mdi-account-group',
    url: '/grupos-trabalho',
    role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
  },
  {
    key: 'aliancas',
    label: 'Alianças',
    isTitle: false,
    icon: 'mdi mdi-account-multiple',
    url: '/aliancas',
    role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
  },
  {
    key: 'equipe-fornecedores',
    label: 'Equipe & Fornecedores',
    isTitle: false,
    icon: 'mdi mdi-account-group-outline',
    collapsed: true,
    children: [
      {
        key: 'equipe',
        label: 'Equipe',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/gestao-equipe',
        parentKey: 'equipe-fornecedores',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'status-equipe',
        label: 'Status de Equipe',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/status-equipe',
        parentKey: 'equipe-fornecedores',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'setor-estrutura-politica',
        label: 'Setor de Estrutura Política',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/setor-estrutura-politica',
        parentKey: 'equipe-fornecedores',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'fornecedores',
        label: 'Gestão de Fornecedores',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/gestao-fornecedores/fornecedores',
        parentKey: 'equipe-fornecedores',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'comparador-fornecedores',
        label: 'Comparador de Fornecedores',
        icon: 'mdi mdi-circle-medium',
        url: '/gestao-fornecedores/comparador',
        parentKey: 'equipe-fornecedores',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
    ],
  },
  {
    label: 'Comunicação',
    isTitle: true,
    show: true,
  },
  {
    key: 'marketing',
    label: 'Marketing',
    isTitle: false,
    icon: 'mdi mdi-email-outline',
    collapsed: true,
    children: [
      {
        key: 'conteudo-exclusivo',
        label: 'Conteúdo Exclusivo',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/conteudo-exclusivo',
        parentKey: 'marketing',
        role: 'ROLE_PORTAL_CONTEUDO_EXCLUSIVO_VISUALIZAR',
      },
      {
        key: 'autor',
        label: 'Autor',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/autor',
        parentKey: 'marketing',
        role: 'ROLE_AUTOR_VISUALIZAR',
      },
      {
        key: 'categorias',
        label: 'Categorias',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/categorias',
        parentKey: 'marketing',
        role: 'ROLE_CATEGORIAS_VISUALIZAR',
      },
      {
        key: 'envios-email',
        label: 'E-mails em Massa',
        url: '/marketing/envios-email',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'marketing',
        role: 'ROLE_E_MAILS_EM_MASSA_VISUALIZAR',
      },
      {
        key: 'notificacoes',
        label: 'Notificações',
        url: '/marketing/notificacoes',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'marketing',
        role: 'ROLE_NOTIFICACOES_VISUALIZAR',
      },
      {
        key: 'modelosEmail',
        label: 'Modelos de E-mail',
        url: '/marketing/modelos-email',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'marketing',
        role: 'ROLE_MODELOS_DE_E_MAIL_VISUALIZAR',
      },
      {
        key: 'tipos-email',
        label: 'Tipos de E-mail',
        url: '/marketing/tipos-email',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'marketing',
        role: 'ROLE_TIPOS_DE_EMAIL_VISUALIZAR',
      },
      {
        key: 'variaveis-email',
        label: 'Variáveis de E-mail',
        url: '/marketing/variaveis-email',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'marketing',
        role: 'ROLE_VARIAVEIS_DE_EMAIL_VISUALIZAR',
      },
      {
        key: 'email-imagens',
        label: 'Imagens de E-mail',
        url: '/marketing/email-imagens',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'marketing',
        role: 'ROLE_EMAIL_IMAGENS_VISUALIZAR',
      },
    ],
  },
  {
    label: 'Inteligência Eleitoral',
    isTitle: true,
    show: true,
  },
  {
    key: 'adversarios',
    label: 'Adversários',
    isTitle: false,
    icon: 'mdi mdi-sword-cross',
    url: '/jogos/adversarios',
    role: 'ROLE_ADVERSARIOS_VISUALIZAR',
  },
  {
    key: 'candidatos',
    label: 'Candidatos',
    isTitle: false,
    icon: 'mdi mdi-account-group',
    collapsed: true,
    children: [
      {
        key: 'candidatos-lista',
        label: 'Candidatos',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorios/candidatos',
        parentKey: 'candidatos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'candidatos-arena',
        label: 'Arena de Confronto',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorios/candidatos/arena',
        parentKey: 'candidatos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'candidatos-confronto-territorial',
        label: 'Confronto Territorial',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorios/candidatos/confronto-territorial',
        parentKey: 'candidatos',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
    ],
  },
  {
    key: 'doadores',
    label: 'Doadores',
    isTitle: false,
    icon: 'mdi mdi-hand-heart-outline',
    url: '/relatorios/doadores',
    role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
  },
  {
    key: 'gestao-riscos',
    label: 'Gestão de Riscos',
    isTitle: false,
    icon: 'mdi mdi-shield-alert-outline',
    url: '/gestao-riscos',
    role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
  },
  {
    label: 'Capacitação',
    isTitle: true,
    show: true,
  },
  {
    key: 'academy',
    label: 'Capacitação',
    isTitle: false,
    icon: 'mdi mdi-school-outline',
    collapsed: true,
    children: [
      {
        key: 'material',
        label: 'Materiais',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/material',
        parentKey: 'academy',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
      {
        key: 'tipo-material',
        label: 'Tipos de Material',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/tipo-material',
        parentKey: 'academy',
        role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
      },
    ],
  },
  {
    label: 'Sistema',
    isTitle: true,
    show: true,
  },
  {
    key: 'socios',
    label: 'Clientes',
    isTitle: false,
    icon: 'mdi mdi-handshake',
    collapsed: true,
    children: [
      {
        key: 'page-socios',
        label: 'Clientes',
        url: '/clientes',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'socios',
        role: 'ROLE_PLANOS_VISUALIZAR',
      },
      {
        key: 'perfil-cliente',
        label: 'Perfil de Clientes',
        url: '/perfil-cliente',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'socios',
        role: 'ROLE_PLANOS_VISUALIZAR',
      },
      {
        key: 'checkin',
        label: 'Check-in',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/checkin',
        parentKey: 'socios',
        role: 'ROLE_CHECKIN_VISUALIZAR',
      },
      {
        key: 'aprovacao-documentos',
        label: 'Aprovar Documentos',
        url: '/aprovacao-de-documentos',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'socios',
        role: 'ROLE_APROVACAO_DE_DOCUMENTOS_VISUALIZAR',
      },
      // {
      //   key: 'consulta-externa',
      //   label: 'Consulta Externa',
      //   icon: 'mdi mdi-circle-medium',
      //   url: '/socios/consulta-externa',
      //   parentKey: 'socios',
      //   role: 'ROLE_CONSULTA_EXTERNA_VISUALIZAR',
      // },
      // {
      //   key: 'blacklist',
      //   label: 'Blacklist',
      //   url: '/socios/blacklist',
      //   icon: 'mdi mdi-circle-medium',
      //   parentKey: 'socios',
      //   role: 'ROLE_BLACKLIST_VISUALIZAR',
      // },
      {
        key: 'planos',
        label: 'Planos',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/planos',
        parentKey: 'socios',
        role: 'ROLE_PLANOS_VISUALIZAR',
      },
      {
        key: 'definicoes-beneficios',
        label: 'Benefícios',
        url: '/definicoes/beneficios',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'socios',
        role: 'ROLE_BENEFICIOS_VISUALIZAR',
      },
    ],
  },
  {
    key: 'relatorios',
    label: 'Relatórios',
    isTitle: false,
    icon: 'mdi mdi-file-chart-outline',
    collapsed: true,
    children: [
      {
        key: 'relatorio-de-pagamentos',
        label: 'Pagamentos',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorio-de-pagamentos',
        parentKey: 'relatorios',
        role: 'ROLE_RELATORIO_DE_PAGAMENTOS_VISUALIZAR',
      },
      {
        key: 'relatorio-de-recebimentos',
        label: 'Recebimentos',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorio-de-recebimentos',
        parentKey: 'relatorios',
        role: 'ROLE_RELATORIO_DE_RECEBIMENTOS_VISUALIZAR',
      },
      {
        key: 'relatorio-de-faturas',
        label: 'Faturas',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorio-de-faturas',
        parentKey: 'relatorios',
        role: 'ROLE_RELATORIO_DE_FATURAS_VISUALIZAR',
      },
      {
        key: 'relatorio-dependentes',
        label: 'Dependentes',
        isTitle: false,
        url: '/relatorios/relatorio-dependentes',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'relatorios',
        role: 'ROLE_DEPENDENTES_VISUALIZAR',
      },
      {
        key: 'relatorio-de-ordens',
        label: 'Ordens',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorios/relatorio-de-ordens',
        parentKey: 'relatorios',
        role: 'ROLE_ORDENS_VISUALIZAR', //ROLE_ORDERS_VISUALIZAR
      },
      {
        key: 'relatorio-inadimplentes',
        label: 'Inadimplentes',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorios/relatorio-inadimplentes',
        parentKey: 'relatorios',
        role: 'ROLE_RELATORIO_DE_INADIMPLENTES_VISUALIZAR',
      },
      {
        key: 'relatorio-recorrencia',
        label: 'Recorrência',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorios/relatorio-recorrencias',
        parentKey: 'relatorios',
        role: 'ROLE_RELATORIO_RECORRENCIA_VISUALIZAR',
      },
      {
        key: 'relatorio-mensal-socios',
        label: 'Sócios',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorios/relatorio-mensal-socios',
        parentKey: 'relatorios',
        role: 'ROLE_RELATORIO_MENSAL_SOCIO_VISUALIZAR',
      },
      {
        key: 'relatorio-usuarios-socios',
        label: 'Usuários x Sócios',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorios/relatorio-usuarios-socios',
        parentKey: 'relatorios',
        role: 'ROLE_RELATORIO_DE_USUARIO_VISUALIZAR',
      },
      {
        key: 'relatorio-movimentacao-de-status',
        label: 'Troca de Status',
        isTitle: false,
        url: '/relatorio-movimentacao-de-status',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'relatorios',
        role: 'ROLE_RELATORIO_DE_STATUS_VISUALIZAR',
      },
      {
        key: 'relatorio-resumo-socios',
        label: 'Resumo de Clientes',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorios/relatorio-resumo-socios',
        parentKey: 'relatorios',
        role: 'ROLE_RESUMO_DE_SOCIOS_VISUALIZAR',
      },
      {
        key: 'relatorio-quadro-resumo',
        label: 'Quadro Resumo',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorios/relatorio-quadro-resumo',
        parentKey: 'relatorios',
        role: 'ROLE_QUADRO_RESUMO_VISUALIZAR',
      },
      {
        key: 'relatorio-renovacoes',
        label: 'Renovações',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorios/relatorio-renovacoes',
        parentKey: 'relatorios',
        role: 'ROLE_RENOVACOES_VISUALIZAR',
      },
      {
        key: 'relatorio-upgrades',
        label: 'Upgrades',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorios/relatorio-upgrades',
        parentKey: 'relatorios',
        role: 'ROLE_UPGRADES_VISUALIZAR',
      },
      {
        key: 'relatorio-estorno',
        label: 'Estornos',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/relatorios/relatorio-estornos',
        parentKey: 'relatorios',
        role: 'ROLE_RELATORIO_DE_ESTORNOS_VISUALIZAR',
      },
    ],
  },
  {
    key: 'exports',
    label: 'Exportar',
    isTitle: false,
    icon: 'mdi mdi-export',
    collapsed: true,
    children: [
      {
        key: 'export-carteirinhas',
        label: 'Carteirinhas',
        url: '/exports/export-carteirinhas',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'exports',
        role: 'ROLE_CARTEIRINHAS_VISUALIZAR',
      },
    ],
  },
  {
    key: 'mgm',
    label: 'MGM',
    isTitle: false,
    icon: 'mdi mdi-arrow-left-right',
    collapsed: true,
    children: [
      {
        key: 'socios-indicaram',
        label: 'Clientes que Indicaram',
        url: '/mgm/socios-indicaram',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'mgm',
        role: 'ROLE_SOCIOS_QUE_INDICARAM_VISUALIZAR',
      },
      {
        key: 'abatimento-pontos',
        label: 'Histórico de Pontos',
        url: '/mgm/abatimento-pontos',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'mgm',
        role: 'ROLE_ABATIMENTO_DE_PONTOS_VISUALIZAR',
      },
    ],
  },
  {
    key: 'parametros-consulta-externa',
    label: 'Integrações',
    isTitle: false,
    icon: 'mdi mdi-view-module',
    collapsed: true,
    children: [
      {
        key: 'parametros-consulta-externa-item',
        label: 'Parâmetros de Consulta Externa',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/parametros-consulta-externa',
        parentKey: 'parametros-consulta-externa',
        role: 'ROLE_PARAMETROS_DE_CONSULTA_EXTERNA_VISUALIZAR',
      },
      {
        key: 'integracoes',
        label: 'Integrações',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/integracoes',
        parentKey: 'parametros-consulta-externa',
        role: 'ROLE_INTEGRACOES_VISUALIZAR',
      },
      {
        key: 'rotinas-batch',
        label: 'Rotinas Batch',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/rotinas-batch',
        parentKey: 'parametros-consulta-externa',
        role: 'ROLE_ROTINAS_BATCH_VISUALIZAR',
      },
    ],
  },
  {
    key: 'account-launch',
    label: 'Administrativo',
    isTitle: false,
    icon: 'mdi mdi-cash-register',
    collapsed: true,
    children: [
      {
        key: 'account-launch-item',
        label: 'Lançamento de Contas',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/lancamento-de-contas',
        parentKey: 'account-launch',
        role: 'ROLE_LANCAMENTO_CONTA_VISUALIZAR',
      },
      {
        key: 'contratos',
        label: 'Contratos',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/contratos',
        parentKey: 'account-launch',
        role: 'ROLE_CONTRATOS_VISUALIZAR',
      },
      {
        key: 'contas',
        label: 'Contas',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/contas',
        parentKey: 'account-launch',
        role: 'ROLE_CONTAS_VISUALIZAR',
      },
      {
        key: 'tipos-taxa-contrato',
        label: 'Tipos de Taxa de Contrato',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/tipos-taxa-contrato',
        parentKey: 'account-launch',
        role: 'ROLE_TIPO_TAXA_CONTRATO_VISUALIZAR',
      },
      {
        key: 'fechamento-mensal',
        label: 'Fechamento Mensal',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/fechamento-mensal',
        parentKey: 'account-launch',
        role: 'ROLE_FECHAMENTO_MENSAL_VISUALIZAR',
      },
      {
        key: 'lancamentos',
        label: 'Lançamentos',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/lancamentos',
        parentKey: 'account-launch',
        role: 'ROLE_LANCAMENTOS_VISUALIZAR',
      },
      {
        key: 'status-relatorio-fechamentos',
        label: 'Status de Relatório de Fechamento',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/status-relatorio-fechamento',
        parentKey: 'account-launch',
        role: 'ROLE_STATUS_RELATORIO_FECHAMENTO_VISUALIZAR',
      },
    ],
  },
  {
    label: 'Configurações',
    isTitle: true,
    show: true,
  },
  {
    key: 'configurar-backoffice',
    label: 'Backoffice',
    isTitle: false,
    icon: 'mdi mdi-web',
    collapsed: true,
    children: [
      {
        key: 'login',
        label: 'Login',
        url: '/configurar-backoffice/login',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-backoffice',
        role: 'ROLE_LOGIN_VISUALIZAR',
      },
    ],
  },
  {
    key: 'configurar-portal',
    label: 'Portal',
    isTitle: false,
    icon: 'mdi mdi-web',
    collapsed: true,
    children: [
      {
        key: 'geral',
        label: 'Geral',
        url: '/configurar-portal/geral',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-portal',
        role: 'ROLE_CONFIGURACAO_GERAL_VISUALIZAR',
      },
      {
        key: 'cabecalho',
        label: 'Cabeçalho',
        url: '/configurar-portal/cabecalho',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-portal',
        role: 'ROLE_CABECALHO_VISUALIZAR',
      },
      {
        key: 'principal',
        label: 'Principal',
        url: '/configurar-portal/principal',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-portal',
        role: 'ROLE_PRINCIPAL_VISUALIZAR',
      },

      {
        key: 'config-planos',
        label: 'Planos',
        url: '/configurar-portal/planos',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-portal',
        role: 'ROLE_PORTAL_PLANOS_VISUALIZAR',
      },
      {
        key: 'beneficios',
        label: 'Benefícios',
        url: '/configurar-portal/beneficios',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-portal',
        role: 'ROLE_PORTAL_BENEFICIOS_VISUALIZAR',
      },
      {
        key: 'banner',
        label: 'Banner',
        url: '/configurar-portal/banner',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-portal',
        role: 'ROLE_BANNER_VISUALIZAR',
      },
      {
        key: 'conteudo-exclusivo-config',
        label: 'Conteúdo Exclusivo',
        url: '/configurar-portal/conteudo-exclusivo',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-portal',
        role: 'ROLE_CONTEUDO_EXCLUSIVO_VISUALIZAR',
      },
      {
        key: 'secao-video',
        label: 'Seção Vídeo',
        url: '/configurar-portal/secao-video',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-portal',
        role: 'ROLE_SECAO_VIDEO_VISUALIZAR',
      },
      {
        key: 'tabela-beneficios',
        label: 'Tabela de Benefícios',
        url: '/configurar-portal/tabela-beneficios',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-portal',
        role: 'ROLE_TABELA_DE_BENEFICIOS_VISUALIZAR',
      },
      {
        key: 'proximos-confrontos',
        label: 'Próximos Confrontos',
        url: '/configurar-portal/proximos-confrontos',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-portal',
        role: 'ROLE_PROXIMOS_CONFRONTOS_VISUALIZAR',
      },
      {
        key: 'tabela-ranking',
        label: 'Tabela de Ranking',
        url: '/configurar-portal/tabela-ranking',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-portal',
        role: 'ROLE_TABELA_DE_RANKING_VISUALIZAR',
      },
      {
        key: 'faq',
        label: 'FAQ',
        url: '/configurar-portal/faq',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-portal',
        role: 'ROLE_FAQ_VISUALIZAR',
      },
      {
        key: 'rodape',
        label: 'Rodapé',
        url: '/configurar-portal/rodape',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'configurar-portal',
        role: 'ROLE_RODAPE_VISUALIZAR',
      },
    ],
  },
  {
    key: 'definicoes',
    label: 'Definições',
    isTitle: false,
    icon: 'mdi mdi-tools',
    collapsed: true,
    children: [
      {
        key: 'url-portais',
        label: 'URL dos Portais',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/url-portais',
        parentKey: 'definicoes',
        role: 'ROLE_URL_PORTAIS_VISUALIZAR'
      },
      {
        key: 'balances',
        label: 'Balanço',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/balances',
        parentKey: 'definicoes',
        role: 'ROLE_BALANCO_VISUALIZAR',
      },
      {
        key: 'definicoes-termos',
        label: 'Termos de Uso',
        url: '/definicoes/termos-de-uso',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'definicoes',
        role: 'ROLE_TERMOS_DE_USO_VISUALIZAR',
      },
      {
        key: 'definicoes-prompt-builder',
        label: 'Prompt Builder',
        url: '/definicoes/prompt-builder',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'definicoes',
        role: 'ROLE_TERMOS_DE_USO_VISUALIZAR',
      },
      {
        key: 'definicoes-politica-privacidade',
        label: 'Política de Privacidade',
        url: '/definicoes/politica-privacidade',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'definicoes',
        role: 'ROLE_POLITICA_DE_PRIVACIDADE_VISUALIZAR',
      },
      {
        key: 'rede-social',
        label: 'Rede Social',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/rede-social',
        parentKey: 'definicoes',
        role: 'ROLE_REDE_SOCIAL_VISUALIZAR',
      },
      {
        key: 'cargos',
        label: 'Cargos',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/cargos',
        parentKey: 'definicoes',
        role: 'ROLE_CARGOS_VISUALIZAR',
      },
      {
        key: 'departamentos',
        label: 'Departamentos',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/departamentos',
        parentKey: 'definicoes',
        role: 'ROLE_DEPARTAMENTOS_VISUALIZAR',
      },
      {
        key: 'definicoes-perguntas-frequentes',
        label: 'Perguntas Frequentes',
        url: '/definicoes/faq',
        icon: 'mdi mdi-circle-medium',
        parentKey: 'definicoes',
        role: 'ROLE_PERGUNTAS_FREQUENTES_VISUALIZAR',
      },
    ],
  },
  {
    key: 'usuariosHead',
    label: 'Segurança',
    isTitle: false,
    icon: 'mdi mdi-security',
    collapsed: true,
    children: [
      {
        key: 'usuarios',
        label: 'Usuários',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/usuarios',
        parentKey: 'usuarios',
        role: 'ROLE_USUARIOS_VISUALIZAR',
      },
      {
        key: 'perfis',
        label: 'Perfis',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/perfis',
        parentKey: 'usuarios',
        role: 'ROLE_PERFIS_VISUALIZAR',
      },
      {
        key: 'funcionalidades',
        label: 'Funcionalidades',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/funcionalidades',
        parentKey: 'usuarios',
        role: 'ROLE_FUNCIONALIDADES_VISUALIZAR',
      },
      {
        key: 'log-sistema',
        label: 'Log do Sistema',
        isTitle: false,
        icon: 'mdi mdi-circle-medium',
        url: '/log-sistema',
        parentKey: 'usuarios',
        role: 'ROLE_LOG_DO_SISTEMA_VISUALIZAR',
      },
    ],
  },
  // {
  //   key: 'lideranca',
  //   label: 'Liderança',
  //   isTitle: false,
  //   icon: 'mdi mdi-account-tie',
  //   collapsed: true,
  //   children: [
  //     {
  //       key: 'tipo-lideranca',
  //       label: 'Tipo de Liderança',
  //       url: '/tipo-lideranca',
  //       icon: 'mdi mdi-circle-medium',
  //       parentKey: 'lideranca',
  //       role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
  //     },
  //     {
  //       key: 'categoria-tipo-lideranca',
  //       label: 'Categoria Tipo Liderança',
  //       url: '/categoria-tipo-lideranca',
  //       icon: 'mdi mdi-circle-medium',
  //       parentKey: 'lideranca',
  //       role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
  //     },
  //   ],
  // },
  {
    key: 'tipos-acao',
    label: 'Geral',
    isTitle: false,
    icon: 'mdi mdi-cog',
    collapsed: true,
    children: [
      {
        key: 'geral-pessoas-cadastros',
        label: 'Pessoas & Cadastros',
        isTitle: false,
        icon: 'mdi mdi-account-box-outline',
        parentKey: 'tipos-acao',
        collapsed: true,
        children: [
          {
            key: 'tipo-pessoa',
            label: 'Tipo de Pessoa',
            url: '/tipo-pessoa',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-pessoas-cadastros',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'cargos-position',
            label: 'Cargos',
            url: '/cargos-pessoa',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-pessoas-cadastros',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'tipos-parlamentares',
            label: 'Tipos de Parlamentares',
            url: '/tipos-de-parlamentares',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-pessoas-cadastros',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'tipo-agente',
            label: 'Tipos de Agente',
            url: '/tipo-agente',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-pessoas-cadastros',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'tipos-vinculo',
            label: 'Tipos de Vínculo',
            url: '/tipos-vinculo',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-pessoas-cadastros',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'funcoes',
            label: 'Funções',
            url: '/funcoes',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-pessoas-cadastros',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'tipo-contato',
            label: 'Tipos de Contato',
            url: '/tipo-contato',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-pessoas-cadastros',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'religiao',
            label: 'Crença/Religião',
            url: '/religiao',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-pessoas-cadastros',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'cor-de-pele',
            label: 'Cor de Pele',
            url: '/cor-de-pele',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-pessoas-cadastros',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
        ],
      },
      {
        key: 'geral-demandas-projetos',
        label: 'Demandas & Projetos',
        isTitle: false,
        icon: 'mdi mdi-clipboard-text-outline',
        parentKey: 'tipos-acao',
        collapsed: true,
        children: [
          {
            key: 'origem-demanda',
            label: 'Origem de Demanda',
            url: '/origem-demandas',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-demandas-projetos',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'status-demandas',
            label: 'Status de Demandas',
            url: '/status-demandas',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-demandas-projetos',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'status-estrategico',
            label: 'Status Estratégico',
            url: '/central-demandas/status-estrategico',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-demandas-projetos',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'solicitante-historico',
            label: 'Solicitantes Históricos',
            url: '/solicitante-historico',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-demandas-projetos',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'atividades-departamento',
            label: 'Atividades por Departamento',
            url: '/atividades-departamento',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-demandas-projetos',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'importancia',
            label: 'Importância',
            url: '/importancia',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-demandas-projetos',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'urgencia',
            label: 'Urgência',
            url: '/urgencia',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-demandas-projetos',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'tipo-foco',
            label: 'Tipos de Foco',
            url: '/tipo-foco',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-demandas-projetos',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
        ],
      },
      {
        key: 'geral-riscos',
        label: 'Riscos',
        isTitle: false,
        icon: 'mdi mdi-shield-alert-outline',
        parentKey: 'tipos-acao',
        collapsed: true,
        children: [
          {
            key: 'status-risco',
            label: 'Status de Risco',
            url: '/status-risco',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-riscos',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'impacto',
            label: 'Impacto',
            url: '/impacto',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-riscos',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'probabilidade',
            label: 'Probabilidade',
            url: '/probabilidade',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-riscos',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'tipos-risco',
            label: 'Tipos de Risco',
            url: '/tipo-risco',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-riscos',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
        ],
      },
      {
        key: 'geral-articulacao-politica',
        label: 'Articulação Política',
        isTitle: false,
        icon: 'mdi mdi-account-tie-outline',
        parentKey: 'tipos-acao',
        collapsed: true,
        children: [
          {
            key: 'partido-politico',
            label: 'Partidos Políticos',
            url: '/political-party',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-articulacao-politica',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'tipo-alianca',
            label: 'Tipos de Aliança',
            url: '/tipo-alianca',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-articulacao-politica',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'status-oportunidade-politica',
            label: 'Status de Oportunidade Política',
            url: '/status-oportunidade-politica',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-articulacao-politica',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'tipo-oportunidade-politica',
            label: 'Tipo de Oportunidade Política',
            url: '/tipo-oportunidade-politica',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-articulacao-politica',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'estagio-apoiador',
            label: 'Estágio de Apoiador',
            url: '/estagio-apoiador',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-articulacao-politica',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'tipo-entidade-apoiadora',
            label: 'Tipo de Entidade Apoiadora',
            url: '/tipo-entidade-apoiadora',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-articulacao-politica',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'setor-entidade',
            label: 'Setor de Entidade',
            url: '/setor-entidade',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-articulacao-politica',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'nivel-formalizacao',
            label: 'Nível de Formalização',
            url: '/nivel-formalizacao',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-articulacao-politica',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'confiabilidade',
            label: 'Confiabilidade',
            url: '/confiabilidade',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-articulacao-politica',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'papel-grupo-trabalho',
            label: 'Papel de Grupo de Trabalho',
            url: '/papel-grupo-trabalho',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-articulacao-politica',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'tipos-agenda',
            label: 'Tipos de Agenda',
            url: '/tipos-de-agenda',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-articulacao-politica',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
        ],
      },
      {
        key: 'geral-clientes-crm',
        label: 'Clientes & CRM',
        isTitle: false,
        icon: 'mdi mdi-handshake-outline',
        parentKey: 'tipos-acao',
        collapsed: true,
        children: [
          {
            key: 'origem-socio',
            label: 'Origem dos Clientes',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/origem-socio',
            parentKey: 'geral-clientes-crm',
            role: 'ROLE_ORIGEM_SOCIO_TORCEDOR_VISUALIZAR',
          },
          {
            key: 'motivos-cadastro',
            label: 'Motivos de Cadastro',
            url: '/clientes/motivos-cadastro',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-clientes-crm',
            role: 'ROLE_MOTIVOS_DE_CADASTRO_VISUALIZAR',
          },
          {
            key: 'situacoes',
            label: 'Situações',
            url: '/clientes/situacoes',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-clientes-crm',
            role: 'ROLE_SITUACOES_VISUALIZAR',
          },
          {
            key: 'tags',
            label: 'Tags',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/tags',
            parentKey: 'geral-clientes-crm',
            role: 'ROLE_TAGS_VISUALIZAR',
          },
          {
            key: 'assuntos-crm',
            label: 'Assuntos de CRM',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/assuntos-crm',
            parentKey: 'geral-clientes-crm',
            role: 'ROLE_ASSUNTOS_CRM_VISUALIZAR',
          },
          {
            key: 'classificacao-socio',
            label: 'Classificação de Clientes',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/classificacao-socio',
            parentKey: 'geral-clientes-crm',
            role: 'ROLE_CLASSIFICACAO_SOCIO_TORCEDOR_VISUALIZAR',
          },
          {
            key: 'status-plano',
            label: 'Status do Plano',
            icon: 'mdi mdi-circle-medium',
            url: '/status-plano',
            parentKey: 'geral-clientes-crm',
            role: 'ROLE_STATUS_DO_PLANO_VISUALIZAR',
          },
          {
            key: 'motivos-cancelamento',
            label: 'Motivos de Cancelamento',
            url: '/motivos-cancelamento',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-clientes-crm',
            role: 'ROLE_MOTIVOS_DE_CANCELAMENTO_VISUALIZAR',
          },
          {
            key: 'rating',
            label: 'Avaliações',
            url: '/rating',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-clientes-crm',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
        ],
      },
      {
        key: 'geral-financeiro',
        label: 'Financeiro',
        isTitle: false,
        icon: 'mdi mdi-cash-multiple',
        parentKey: 'tipos-acao',
        collapsed: true,
        children: [
          {
            key: 'tipos-plano',
            label: 'Tipos de Plano',
            url: '/tipos-plano',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-financeiro',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'nivel-plano',
            label: 'Níveis de Plano',
            url: '/nivel-plano',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-financeiro',
            role: 'ROLE_NIVEIS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'tipo-status-pagamento',
            label: 'Tipo de Status de Pagamento',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/tipo-status-pagamento',
            parentKey: 'geral-financeiro',
            role: 'ROLE_TIPO_STATUS_PAGAMENTO_VISUALIZAR',
          },
          {
            key: 'tipo-de-pagamento',
            label: 'Tipo de Pagamento',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/tipo-de-pagamento',
            parentKey: 'geral-financeiro',
            role: 'ROLE_TIPO_DE_PAGAMENTO_VISUALIZAR',
          },
          {
            key: 'tipos-taxa',
            label: 'Tipos de Taxa',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/tipos-taxa',
            parentKey: 'geral-financeiro',
            role: 'ROLE_TIPOS_DE_TAXA_VISUALIZAR',
          },
          {
            key: 'valores',
            label: 'Valores de Taxa',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/valores-taxa',
            parentKey: 'geral-financeiro',
            role: 'ROLE_VALORES_TAXA_VISUALIZAR',
          },
          {
            key: 'tipos-fatura',
            label: 'Tipos de Fatura',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/tipos-fatura',
            parentKey: 'geral-financeiro',
            role: 'ROLE_TIPOS_DE_FATURA_VISUALIZAR',
          },
          {
            key: 'motivos-cancelamento-fatura',
            label: 'Motivos de Cancelamento de Fatura',
            url: '/clientes/motivos-cancelamento-fatura',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-financeiro',
            role: 'ROLE_MOTIVOS_DE_CANCELAMENTO_DE_FATURA_VISUALIZAR',
          },
          {
            key: 'motivos-estorno-fatura',
            label: 'Motivos de Estorno de Fatura',
            url: '/clientes/motivos-estorno-fatura',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-financeiro',
            role: 'ROLE_MOTIVOS_DE_ESTORNO_DE_FATURA_VISUALIZAR',
          },
          {
            key: 'cupons',
            label: 'Cupons',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/cupons',
            parentKey: 'geral-financeiro',
            role: 'ROLE_CUPONS_VISUALIZAR',
          },
          {
            key: 'cupons-por-cpf',
            label: 'Cupons por CPF',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/cupons-por-cpf',
            parentKey: 'geral-financeiro',
            role: 'ROLE_CUPONS_VISUALIZAR',
          },
        ],
      },
      {
        key: 'geral-estrutura-comercial',
        label: 'Estrutura & Comercial',
        isTitle: false,
        icon: 'mdi mdi-domain',
        parentKey: 'tipos-acao',
        collapsed: true,
        children: [
          {
            key: 'unidades-estrategicas',
            label: 'Unidades Estratégicas',
            url: '/unidades-estrategicas',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-estrutura-comercial',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'esferas',
            label: 'Esferas',
            url: '/esferas',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-estrutura-comercial',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'departamentos-acao',
            label: 'Departamentos',
            url: '/departamentos-acao',
            icon: 'mdi mdi-circle-medium',
            parentKey: 'geral-estrutura-comercial',
            role: 'ROLE_TIPOS_DE_PLANO_VISUALIZAR',
          },
          {
            key: 'modulos',
            label: 'Módulos',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/modulos',
            parentKey: 'geral-estrutura-comercial',
            role: 'ROLE_MODULOS_VISUALIZAR',
          },
          {
            key: 'club-modulos',
            label: 'Módulos x Clubes',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/modulos-clubes',
            parentKey: 'geral-estrutura-comercial',
            role: 'ROLE_MODULOS_CLUBES_VISUALIZAR',
          },
          {
            key: 'parceiros',
            label: 'Parceiros',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/parceiros',
            parentKey: 'geral-estrutura-comercial',
            role: 'ROLE_PARCEIROS_VISUALIZAR',
          },
          {
            key: 'locais-venda',
            label: 'Locais de Venda',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/locais-venda',
            parentKey: 'geral-estrutura-comercial',
            role: 'ROLE_LOCAIS_DE_VENDA_VISUALIZAR',
          },
          {
            key: 'servicos-produtos',
            label: 'Serviços e Produtos',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/servicos-produtos',
            parentKey: 'geral-estrutura-comercial',
            role: 'ROLE_SERVICOS_PRODUTOS_VISUALIZAR',
          },
          {
            key: 'tipos-acao-menu',
            label: 'Tipos de Ação Log',
            isTitle: false,
            icon: 'mdi mdi-circle-medium',
            url: '/tipos-acao',
            parentKey: 'geral-estrutura-comercial',
            role: 'ROLE_TIPOS_DE_ACAO_LOG_VISUALIZAR',
          },
        ],
      },
    ],
  },

  // {
  //     key: 'forms',
  //     label: 'forms',
  //     isTitle: false,
  //     icon: 'mdi mdi-handshake',
  //     url: '/forms',
  // }
];

const HORIZONTAL_MENU_ITEMS: MenuItem[] = [];

export { HORIZONTAL_MENU_ITEMS, MENU_ITEMS };

